import { render, staticRenderFns } from "./MoralHabit.vue?vue&type=template&id=00836149&scoped=true"
import script from "./MoralHabit.vue?vue&type=script&lang=js"
export * from "./MoralHabit.vue?vue&type=script&lang=js"
import style0 from "./MoralHabit.vue?vue&type=style&index=0&id=00836149&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00836149",
  null
  
)

export default component.exports